import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../component/home/home.vue'
import AreaRiservata from '../component/area-riservata/area-riservata.vue'
import AreaRiservataHome from '../component/area-riservata/area-riservata-home/area-riservata-home.vue'
import AreaRiservataScheda from '../component/area-riservata/area-riservata-scheda/area-riservata-scheda.vue'
import AreaRiservataProfile from '../component/area-riservata/area-riservata-profile/area-riservata-profile.vue'
import AreaRiservataZerouno from '../component/area-riservata/area-riservata-zerouno/area-riservata-zerouno.vue'
import AreaRiservataContact from '../component/area-riservata/area-riservata-contact/area-riservata-contact.vue'
import AuthService from '../service/auth.js'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [{
    name: 'home',
    path: '/',
    component: Home
  }, {
    name: 'private',
    path: '/private',
    component: AreaRiservata,
    meta: { auth: true },
    children: [{
      name: 'private-home',
      path: '',
      component: AreaRiservataHome,
      meta: { auth: true }
    }, {
      name: 'private-profile',
      path: 'profile',
      component: AreaRiservataProfile,
      meta: { auth: true }
    }, {
      name: 'private-zerouno',
      path: 'zerouno',
      component: AreaRiservataZerouno,
      meta: { auth: true }
    }, {
      name: 'private-contact',
      path: 'contact',
      component: AreaRiservataContact,
      meta: { auth: true }
    }, {
      name: 'private-scheda',
      path: 'detail/:id',
      component: AreaRiservataScheda,
      meta: { auth: true }
    }]
  }]
})

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) { return record.meta.auth }) && !AuthService.state.ID) {
    next(false)
  } else {
    next()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/core/router.js